import { Boolean, Null, Record, String } from 'runtypes';

export const PhoneCallExtrasRunType = Record({
	bearerToken: String,
	callerName: String.Or(Null),
	faxPages: String.Or(Null),
	faxType: String,
	isAFax: Boolean,
	outgoingCallCallerName: String,
	theMsnIsVisibleForThisCallList: Boolean,
	thePrintCallButtonIsActivated: Boolean,
});

export const PhoneCallSpoingExtrasRunType = Record({
	callGroupId: String,
});
